var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLovebrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 12.3377C29 14.2735 28.6204 15.7098 27.2255 17.2041C27.0461 17.3963 26.7415 17.6735 26.7415 17.6735L16.0942 28L5.4469 17.6735L4.96294 17.2041C2.11719 14.3431 2.47695 10.0284 5.3227 7.16741C8.19641 4.27833 12.878 4.27833 15.7517 7.16741L16.0939 7.51144L16.4359 7.16761C17.8138 5.78169 19.6903 5 21.6505 5C23.6108 5 25.4872 5.78161 26.8651 7.16741C28.2338 8.54288 29 10.4021 29 12.3377Z",
    stroke: "#020617",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLovebrand);
export default __webpack_public_path__ + "static/media/icon-lovebrand.8dacabf86e27c06119b0a2fad59fef30.svg";
export { ForwardRef as ReactComponent };